// Layout related store state and actions.
// (Can be removed once we've decided on a final layout).

// State
export const state = {
	layoutType: 'vertical',
	layoutWidth: 'fluid',
	leftSidebarTheme: 'light',
	leftSidebarType: 'fixed',
}

// Getters
export const getters = {}

// Mutations
export const mutations = {
	CHANGE_LAYOUT(state, layoutType) {
		state.layoutType = layoutType
	},
	CHANGE_LEFT_SIDEBAR_THEME(state, leftSidebarTheme) {
		state.leftSidebarTheme = leftSidebarTheme
	},
	CHANGE_LEFT_SIDEBAR_TYPE(state, leftSidebarType) {
		state.leftSidebarType = leftSidebarType
	},
	CHANGE_LAYOUT_WIDTH(state, layoutWidth) {
		state.layoutWidth = layoutWidth
	}
}

// Actions
export const actions = {
	changeLayoutType({ commit }, { layoutType }) {
		commit('CHANGE_LAYOUT', layoutType)
	},

	changeLeftSidebarTheme({ commit }, { leftSidebarTheme }) {
		commit('CHANGE_LEFT_SIDEBAR_THEME', leftSidebarTheme)
	},

	changeLeftSidebarType({ commit }, { leftSidebarType }) {
		commit('CHANGE_LEFT_SIDEBAR_TYPE', leftSidebarType)
	},

	changeLayoutWidth({ commit }, { layoutWidth }) {
		commit('CHANGE_LAYOUT_WIDTH', layoutWidth)
	}
}
